import React from 'react';

export const ResourceContext = React.createContext();

const ResourceProvider = ({ children, resources, dataProvider }) => {
  return (
    <ResourceContext.Provider
      value={{
        resources,
        dataProvider,
      }}>
      {children}
    </ResourceContext.Provider>
  );
};

export default ResourceProvider;